import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';
import { v4 } from 'uuid';

class CmsDiveCenterStore {
  @observable diveCenter = null;
  @observable bannerImages = [];
  @observable loading = false;

  @action getData() {
    this.loading = true;

    return apiCaller.CmsDiveCenters.get().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.diveCenter = resp.data;
          this.bannerImages = [];
          this.diveCenter.logoUrl = this.diveCenter.logoUrl || '';
          this.diveCenter.bannerUrl = this.diveCenter.bannerUrl || '';

          if (this.diveCenter.bannerUrl) {
            try {
              let imagesJson = JSON.parse(this.diveCenter.bannerUrl);
              imagesJson.map(imageJson => {
                return imageJson.isLoading = false;
              });
              this.bannerImages = imagesJson;
            } catch {
              this.bannerImages.push({
                id: v4(),
                url: this.diveCenter.bannerUrl,
                isLoading: false
              });
            }
          }

          this.bannerImages.push({
            id: v4(),
            url: '',
            isLoading: false
          });

          this.loading = false;
        }
      }
    })
  }

  @action getDataByLanguageCode() {
    this.loading = true;

    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsDiveCenters.getByLanguageCode(languageCode).then(resp => {
      if (resp) {
        this.diveCenter = resp;
        this.bannerImages = [];
        this.diveCenter.logoUrl = this.diveCenter.logoUrl || '';
        this.diveCenter.bannerUrl = this.diveCenter.bannerUrl || '';

        if (this.diveCenter.bannerUrl) {
          try {
            let imagesJson = JSON.parse(this.diveCenter.bannerUrl);
            imagesJson.map(imageJson => {
              return imageJson.isLoading = false;
            });
            this.bannerImages = imagesJson;
          } catch {
            this.bannerImages.push({
              id: v4(),
              url: this.diveCenter.bannerUrl,
              isLoading: false
            });
          }
        }

        this.loading = false;
      }
    })
  }

  @action update() {
    this.loading = true;
    this.diveCenter.bannerUrl = JSON.stringify(this.bannerImages.filter(fi => fi.url !== ''));
    return apiCaller.CmsDiveCenters.update(this.diveCenter.id, this.diveCenter);
  }

  @action setdescription(langId, value) {
    let lang = this.diveCenter.diveCenterLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.description = value;
    }
  }

  @action setloading(value) {
    this.loading = value;
  }

  @action setbannerUrlById(id, value) {
    let image = this.bannerImages.find(fi => fi.id === id);
    if (image) {
      image.url = value;
    }

    let blankImage = this.bannerImages.find(fi => fi.url === '');
    if (!blankImage) {
      this.bannerImages.push({
        id: v4(),
        url: '',
        isLoading: false
      });
    }
  }

  @action setbannerUrlIsLoading(id, isLoading) {
    let image = this.bannerImages.find(fi => fi.id === id);
    if (image) {
      image.isLoading = isLoading;
    }
  }

  @action removeBannerImageById(id) {
    this.bannerImages = this.bannerImages.filter(fi => fi.id !== id);
  }

  @action setlogoUrl(value) {
    this.diveCenter.logoUrl = value;
  }

  @action resetData() {
    this.diveCenter = null;
  }
}

export default new CmsDiveCenterStore();